<template>
    <div>
        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content" key="resumen" id="resumen">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('partido.resumen_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('partido.revisa_datos') }}.</div>
                            <ResumenCompraComponent 
                                :entradas="asientos" 
                                :formulario="formulario"
                                :datos="datos_comprador"
                                :session_id="session_id"
                                @terminado="procesarPago"
                            />					
                        </div>
                    </div>
                </div>
            </section>
        </transition>
        <transition name="fade" mode="out-in">
            <section v-if="procesar_pago" class="padding-vertical-content" key="formulario-pago" id="formulario-pago">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                            <PagoPaycometComponent
                                ref="pago"
                                tipo_venta="pack"
                                :jet_id="jet_id"
                                :session_id="session_id"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </transition>
    </div>
</template>

<script>
import ResumenCompraComponent from '@/components/frontend/events/compra/ResumenCompraComponent';
import PagoPaycometComponent from "@/components/frontend/compra/components/PagoPaycometComponent"

export default {
    props: {
        asientos: {
            required: true,
            type: Array
        },
        formulario: {
            required: false,
            type: String,
        },
        jet_id: {
            required: false,
            type: String
        },
        datos_comprador: {
            required: true,
            type: Object
        },
        session_id: {
            required: true,
            type: String
        }
    },
    data() {
        return {
            procesar_pago: false
        }
    },
    methods: {
        procesarPago() {
            this.procesar_pago = true;
            this.$nextTick(() => {
                this.$scrollTo('#formulario-pago', 220);
            });
        }
    },
    components: { ResumenCompraComponent, PagoPaycometComponent }
}
</script>